import React, { useState } from "react";
import "./ShowBoxes.css";
import Logo from "../../../assets/images/logo-main.png";
import { Popover } from "@mui/material";
import LocalModal from "../Modal/Modal";
import fetchData from "../../../shared/fetchData";
import Button from "../../UI/Button/Button";
import { toast } from "react-toastify";

const ShowBoxes = (props) => {
  const [lockerId, setLockerId] = useState(undefined);
  const [anchorEl, setAnchorEl] = useState(null);
  const [modalContent, setModalContent] = useState(null);
  const ref = React.useRef();

  const lockerChangeStateSubmited = () => {
    var raw = JSON.stringify({
      locker: {
        id: lockerId,
      },
      pl: 1000,
      pn: 1,
      version: "mtpx001",
    });
    var url = "management/api/v1/lockers/changeLockerState";
    fetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == 0) {
          ref.current.closeModal();
          props.showLockers(props.kioskId);
        }
      })
      .catch((error) => console.log());
  };

  const lockerChangeMonitoringStateSubmited = () => {
    var raw = JSON.stringify({
      locker: {
        id: lockerId,
      },
      pl: 1000,
      pn: 1,
      version: "mtpx001",
    });
    var url = "management/api/v1/lockers/changeLockerMonitorState";
    fetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == 0) {
          toast.success("عملیات با موفقیت انجام شد");
          ref.current.closeModal();
          props.showLockers(props.kioskId);
        }
      })
      .catch((error) => console.log());
  };

  const changeState = () => {
    setModalContent(
      <div>
        <div className="row justify-content-center">
          آيا از تغيير وضعيت مطمئن هستيد؟
        </div>
        <div className="row justify-content-center mt-5">
          <div className="col-6">
            <Button btnType="Success" clicked={lockerChangeStateSubmited}>
              بله
            </Button>
          </div>
          <div className="col-6">
            <Button btnType="General" clicked={() => ref.current.closeModal()}>
              خير
            </Button>
          </div>
        </div>
      </div>
    );
    handleClose();
    ref.current.openModal();
  };
  const changeMonitoringState = () => {
    setModalContent(
      <div>
        <div className="row justify-content-center">
          آيا از تغيير وضعيت مانیتورینگ مطمئن هستيد؟
        </div>
        <div className="row justify-content-center mt-5">
          <div className="col-6">
            <Button
              btnType="Success"
              clicked={lockerChangeMonitoringStateSubmited}
            >
              بله
            </Button>
          </div>
          <div className="col-6">
            <Button btnType="General" clicked={() => ref.current.closeModal()}>
              خير
            </Button>
          </div>
        </div>
      </div>
    );
    handleClose();
    ref.current.openModal();
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const box1 = [];
  const box2 = [];
  const box3 = [];

  if (props != null && props.boxes != null && props.boxes.length != 0) {
    props.boxes.sort((a, b) => parseInt(a.serial) - parseInt(b.serial));
    for (var i = 1; i <= 25; i++) {
      if (i < 10) {
        box1.push(
          props.boxes.filter((b) => b.serial == i) != null &&
            props.boxes.filter((b) => b.serial == i).length != 0
            ? props.boxes.filter((b) => b.serial == i)[0]
            : ""
        );
      } else if (i < 17) {
        box2.push(
          props.boxes.filter((b) => b.serial == i) != null &&
            props.boxes.filter((b) => b.serial == i).length != 0
            ? props.boxes.filter((b) => b.serial == i)[0]
            : ""
        );
      } else if (i < 26) {
        box3.push(
          props.boxes.filter((b) => b.serial == i) != null &&
            props.boxes.filter((b) => b.serial == i).length != 0
            ? props.boxes.filter((b) => b.serial == i)[0]
            : ""
        );
      }
    }
  }

  const open = Boolean(anchorEl);
  const id = open ? lockerId : undefined;
  let box2desktop = 0;

  const popupContent = (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
    >
      <div className="row m-0 pl-2 pr-2">
        <div
          // variant="contained"
          style={{
            cursor: "pointer",
            color: "black",
            fontSize: 12,
            padding: 8,
            fontFamily: "iranyekan",
          }}
          onClick={changeState}
        >
          تغییر وضعیت
        </div>
      </div>
      <div className="row m-0 pl-2 pr-2">
        <div
          // variant="contained"
          style={{
            cursor: "pointer",
            color: "black",
            fontSize: 12,
            padding: 8,
            fontFamily: "iranyekan",
          }}
          onClick={changeMonitoringState}
        >
          تغییر وضعیت مانیتورینگ
        </div>
      </div>
    </Popover>
  );
  return (
    <div className="row justify-content-center" dir="ltr">
      <div className="col-4">
        {box1.map((l) => {
          const finalOrders =
            props.checkOrders != null && props.checkOrders == true
              ? l.orders != null && l.orders.length != 0
                ? l.orders.filter((o) => o.state === "R").length > 0
                  ? true
                  : false
                : false
              : "";
          const className =
            props.checkOrders != null && props.checkOrders == true
              ? l.orders != null && l.orders.length != 0
                ? finalOrders
                  ? "map-lckr-has-ord"
                  : "map-lckr-col-full"
                : "map-lckr-col-empty"
              : "";
          const doorClassName =
            props.chechDoors != null && props.chechDoors == true
              ? l.doorState != null && l.doorState == "0"
                ? "map-lckr-col-full"
                : "map-lckr-col-empty"
              : "";
          return (
            <div className="row p-2">
              <div
                className={[
                  props.checkIsActive != null && props.checkIsActive == true
                    ? l.isActive == "1"
                      ? "lckr-col"
                      : "lckr-col-deactive"
                    : "",
                  className,
                  doorClassName,
                ].join(" ")}
              >
                {props.checkOrders != null && props.checkOrders == true ? (
                  <div>
                    {l.orders != null && l.orders.length != 0 ? (
                      <div
                        className="col-12 p-0 text-center"
                        onClick={(event) => {
                          // props.boxClicked(event, l.id)

                          setLockerId(l.id);
                          setAnchorEl(anchorEl ? null : event.currentTarget);
                        }}
                      >
                        سریال: {l.serial}
                      </div>
                    ) : (
                      <div className="col-12 text-center">
                        سریال: {l.serial}
                      </div>
                    )}
                  </div>
                ) : (
                  <div
                    className="col-12 p-0 text-center"
                    onClick={(event) => {
                      // props.boxClicked(event, l.id)

                      setLockerId(l.id);
                      setAnchorEl(anchorEl ? null : event.currentTarget);
                    }}
                  >
                    سریال: {l.serial}
                  </div>
                )}
              </div>
              {popupContent}
            </div>
          );
        })}
      </div>
      <div className="col-4">
        {box2.map((l) => {
          box2desktop++;

          const finalOrders =
            props.checkOrders != null && props.checkOrders == true
              ? l.orders != null && l.orders.length != 0
                ? l.orders.filter((o) => o.state === "R").length > 0
                  ? true
                  : false
                : false
              : "";
          const className =
            props.checkOrders != null && props.checkOrders == true
              ? l.orders != null && l.orders.length != 0
                ? finalOrders
                  ? "map-lckr-has-ord"
                  : "map-lckr-col-full"
                : "map-lckr-col-empty"
              : "";
          const doorClassName =
            props.chechDoors != null && props.chechDoors == true
              ? l.doorState != null && l.doorState == "0"
                ? "map-lckr-col-full"
                : "map-lckr-col-empty"
              : "";
          return (
            <span>
              {box2desktop === 3 ? (
                <span>
                  <div className="row pr-2 pl-2">
                    <div className="empty-lck">
                      <div className="empty-lck-cntnt">
                        <div className="empty-lck-text">
                          <img src={Logo} width="180px" className="desk-only" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row p-2">
                    <div
                      className={[
                        props.checkIsActive != null &&
                        props.checkIsActive == true
                          ? l.isActive == "1"
                            ? "lckr-col"
                            : "lckr-col-deactive"
                          : "",
                        className,
                        doorClassName,
                      ].join(" ")}
                    >
                      {props.checkOrders != null &&
                      props.checkOrders == true ? (
                        <span>
                          {l.orders != null && l.orders.length != 0 ? (
                            <div
                              className="col-12 p-0 text-center"
                              onClick={(event) => {
                                setLockerId(l.id);
                                setAnchorEl(
                                  anchorEl ? null : event.currentTarget
                                );
                                // props.boxClicked(event, l.id)
                              }}
                            >
                              سریال: {l.serial}
                            </div>
                          ) : (
                            <div className="col-12 text-center">
                              سریال: {l.serial}
                            </div>
                          )}
                        </span>
                      ) : (
                        <div
                          className="col-12 p-0 text-center"
                          onClick={(event) => {
                            setLockerId(l.id);
                            setAnchorEl(anchorEl ? null : event.currentTarget);
                            // props.boxClicked(event, l.id)
                          }}
                        >
                          سریال: {l.serial}
                        </div>
                      )}
                    </div>
                  </div>
                </span>
              ) : (
                <div className="row p-2">
                  <div
                    className={[
                      props.checkIsActive != null && props.checkIsActive == true
                        ? l.isActive == "1"
                          ? "lckr-col"
                          : "lckr-col-deactive"
                        : "",
                      className,
                      doorClassName,
                    ].join(" ")}
                  >
                    {props.checkOrders != null && props.checkOrders == true ? (
                      <span>
                        {l.orders != null && l.orders.length != 0 ? (
                          <div
                            className="col-12 p-0 text-center"
                            onClick={(event) => {
                              setLockerId(l.id);
                              setAnchorEl(
                                anchorEl ? null : event.currentTarget
                              );
                              // props.boxClicked(event, l.id)
                            }}
                          >
                            سریال: {l.serial}
                          </div>
                        ) : (
                          <div className="col-12 text-center">
                            سریال: {l.serial}
                          </div>
                        )}
                      </span>
                    ) : (
                      <div
                        className="col-12 p-0 text-center"
                        onClick={(event) => {
                          setLockerId(l.id);
                          setAnchorEl(anchorEl ? null : event.currentTarget);
                          // props.boxClicked(event, l.id)
                        }}
                      >
                        سریال: {l.serial}
                      </div>
                    )}
                  </div>
                </div>
              )}
              {popupContent}
            </span>
          );
        })}
      </div>
      <div className="col-4">
        {box3.map((l) => {
          const finalOrders =
            props.checkOrders != null && props.checkOrders == true
              ? l.orders != null && l.orders.length != 0
                ? l.orders.filter((o) => o.state === "R").length > 0
                  ? true
                  : false
                : false
              : "";
          const className =
            props.checkOrders != null && props.checkOrders == true
              ? l.orders != null && l.orders.length != 0
                ? finalOrders
                  ? "map-lckr-has-ord"
                  : "map-lckr-col-full"
                : "map-lckr-col-empty"
              : "";
          const doorClassName =
            props.chechDoors != null && props.chechDoors == true
              ? l.doorState != null && l.doorState == "0"
                ? "map-lckr-col-full"
                : "map-lckr-col-empty"
              : "";
          return (
            <div className="row p-2">
              <div
                className={[
                  props.checkIsActive != null && props.checkIsActive == true
                    ? l.isActive == "1"
                      ? "lckr-col"
                      : "lckr-col-deactive"
                    : "",
                  className,
                  doorClassName,
                ].join(" ")}
              >
                {props.checkOrders != null && props.checkOrders == true ? (
                  <span>
                    {l.orders != null && l.orders.length != 0 ? (
                      <div
                        className="col-12 p-0 text-center"
                        onClick={(event) => {
                          setLockerId(l.id);
                          setAnchorEl(anchorEl ? null : event.currentTarget);
                          // props.boxClicked(event, l.id)
                        }}
                      >
                        سریال: {l.serial}
                      </div>
                    ) : (
                      <div className="col-12 text-center">
                        سریال: {l.serial}
                      </div>
                    )}
                  </span>
                ) : (
                  <div
                    className="col-12 p-0 text-center"
                    onClick={(event) => {
                      setLockerId(l.id);
                      setAnchorEl(anchorEl ? null : event.currentTarget);
                      // props.boxClicked(event, l.id)
                    }}
                  >
                    سریال: {l.serial}
                  </div>
                )}
              </div>
            </div>
          );
        })}
        {popupContent}
      </div>
      <LocalModal
        content={modalContent}
        ref={ref}
        closePermission="true"
        closeModal={(event) => {}}
      />
    </div>
  );
};
export default ShowBoxes;
